'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RecentlyVisited = require('./RecentlyVisited');

var _RecentlyVisited2 = _interopRequireDefault(_RecentlyVisited);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RecentlyVisited2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/RecentlyVisited/index.js
// module id = 275
// module chunks = 11